import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M22 11.0116H8.01V8.99501H17.12L15.55 7.41764L16.97 6L22 11.0116ZM7.03 18L8.45 16.5824L6.88 15.005H15.99V12.9884H2L7.03 18Z" fill={ fill || 'currentColor' } />
    </svg>
);
